import React from 'react'
import { bool, func, object } from 'prop-types'
import Modal from '../Modal/Modal'
import IcoCalendar from '../icons/IcoCalendar'
import { BtnDanger, BtnGhost, BtnPrimary } from '../ui/buttons'
import { WHATSAPP_EQUIPE_TAG } from '../../data/links'
import { theme } from '../../styles'
import { Callout, ConfirmFooter, ErroMsg } from './cancel-flow-styles'

export default function CancelConfirm( { sub, submitting, erro, onBack, onClose, onConfirm } ) {
  const footer = (
    <ConfirmFooter>
      <BtnGhost
        disabled={ submitting }
        onClick={ onBack }
        type="button"
      >Voltar
      </BtnGhost>
      <BtnPrimary
        as="a"
        href={ WHATSAPP_EQUIPE_TAG }
        rel="noopener noreferrer"
        target="_blank"
      >Falar com equipe TAG
      </BtnPrimary>
      <BtnDanger
        disabled={ submitting }
        onClick={ onConfirm }
        type="button"
      >
        { submitting ? 'Cancelando…' : 'Confirmar cancelamento' }
      </BtnDanger>
    </ConfirmFooter>
  )

  return (
    <Modal
      canClose={ !submitting }
      eyebrow="Cancelar renovação"
      footer={ footer }
      onClose={ onClose }
      steps={{ 'cur': 2 }}
      title="Confirmar cancelamento"
      wide
    >
      <Callout>
        <IcoCalendar
          height="20"
          style={{ 'color': theme.cores.accent, 'flex': 'none' }}
          width="20"
        />
        <span>
          { sub.comEstorno ? (
            <>
              Sua renovação { sub.edicaoAtual } já foi cobrada. Ao cancelar, o valor será
              estornado no mesmo método de pagamento em até 3 dias úteis.
            </>
          ) : (
            <>
              { sub.proximaEdicao
                ? <>Ao cancelar, sua assinatura não será renovada para { sub.proximaEdicao }.</>
                : <>Ao cancelar, sua assinatura não será renovada para o próximo ciclo.</> }
              <br />
              Mas você continua tendo acesso normalmente aos conteúdos exclusivos até o fim do
              ciclo vigente.
            </>
          ) }
        </span>
      </Callout>
      { erro ? (
        <ErroMsg>Não foi possível concluir o cancelamento agora. Tente novamente em instantes.</ErroMsg>
      ) : null }
    </Modal>
  )
}

CancelConfirm.propTypes = {
  'sub': object.isRequired,
  'submitting': bool,
  'erro': bool,
  'onBack': func.isRequired,
  'onClose': func.isRequired,
  'onConfirm': func.isRequired
}

CancelConfirm.defaultProps = {
  'submitting': false,
  'erro': false
}
